import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    selectWinnings,
    selectPrizesLoading,
    selectPrizesError,
    selectPrizesOffline,
    selectPrizesData
} from '../selectors/prize.selector';
import { usePrizeActions } from './usePrizeActions';

export const usePrizeListData = () => {
    const { getPrizes } = usePrizeActions();
    const prizes = useSelector(selectWinnings);
    const pageData = useSelector(selectPrizesData) || {};
    const loading = useSelector(selectPrizesLoading);
    const error = useSelector(selectPrizesError);
    const offlinePayment = useSelector(selectPrizesOffline);

    useEffect(() => {
        getPrizes();
    }, []);

    return {
        prizes,
        identityTaxVerified: pageData.identityTaxVerified,
        loading,
        error,
        offlinePayment
    };
};
